import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
export const getFormFieldIdWithProductSuffix = (
  product: ProductBackendName,
  fieldNameBase: string,
  fieldNameValue?: string,
): string => {
  const value = fieldNameValue !== undefined ? `-${fieldNameValue}` : "";
  return `${fieldNameBase}_${product}${value}`;
};
